seedWebApp.controller('QuotationRoutesController', ['$scope', '$rootScope', '$window', '$route', '$uibModal', 'MaterialService',
    function ($scope, $rootScope, $window, $route, $uibModal, MaterialService) {
        console.log('QuotationRoutesController');
        
      
    }
    ]
);